<template>
  <div class="sm-notification-top">
    <div class="sm-wrap">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'top-notification'
}
</script>
